import { useContext } from 'react';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useMutation } from 'react-query';
import { ReadAllNotifications } from 'services/apiServices';
import { Errors, ReadAllNotificationsResult } from 'types/ApiServicesTypes';

export default function useReadAllNotifications() {
  const { showAlert } = useContext(ToastContext);
  const mutation = useMutation<ReadAllNotificationsResult, Errors>(
    'ReadAllNotifications',
    () =>
      ReadAllNotifications()
        .then(res => {
          return res;
        })
        .catch(err => {
          // showAlert(err.message as string);
          return err;
        }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
}
